import Vue from "vue";
import Vuex from "vuex";
// import createPersistedState from "vuex-persistedstate";
// import Cookies from 'js-cookie'
import user from './modules/user'
import dict from './modules/dict';

import getters from "./getters";
Vue.use(Vuex);

const store = new Vuex.Store({
  // plugins: [createPersistedState(
  //     {
  //       storage: window.Cookies,
  //       reducer(val) {
  //         return {
  //           // 只储存state中的user
  //           app: val.app
  //           // test: val.test
  //         }
  //       }
  //     }
  // )],
  modules: {
    user,
    dict,
  },
  getters
});

export default store;
